export const MATERIALS_CATALOG_ACCESS_DENIED = 'MATERIALS_CATALOG_ACCESS_DENIED';
export const MATERIALS_CATALOG_GLOBAL_READ_ONLY = 'MATERIALS_CATALOG_GLOBAL_READ_ONLY';
export const MATERIALS_CATALOG_MATERIAL_NOT_FOUND = 'MATERIALS_CATALOG_MATERIAL_NOT_FOUND';
export const MATERIALS_CATALOG_OVERRIDE_NOT_FOUND = 'MATERIALS_CATALOG_OVERRIDE_NOT_FOUND';
export const MATERIALS_CATALOG_DUPLICATE_DISPLAY_NAME = 'MATERIALS_CATALOG_DUPLICATE_DISPLAY_NAME';
export const MATERIALS_CATALOG_INVALID_PRESENTATION = 'MATERIALS_CATALOG_INVALID_PRESENTATION';
export const MATERIALS_CATALOG_INVALID_OVERRIDE = 'MATERIALS_CATALOG_INVALID_OVERRIDE';
export const MATERIALS_CATALOG_LIMIT_EXCEEDED = 'MATERIALS_CATALOG_LIMIT_EXCEEDED';
